import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';

import PromotionPage from '../../app-customer/profile/promotion/PromotionPage.vue';
import ServicesPage from '../../app-customer/profile/services/ServicesPage.vue';
import FilterCreate from '../../app-customer/profile/services/FilterCreate.vue';
import FilterListItem from '../../app-customer/profile/services/FilterListItem.vue';
import FilterDetailsMatching from '../../app-customer/profile/services/FilterDetails/FilterDetailsMatching.vue';
import FilterDetailsQuick from '../../app-customer/profile/services/FilterDetails/FilterDetailsQuick.vue';
import FilterDetailsLocation from '../../app-customer/profile/services/FilterDetails/FilterDetailsLocation.vue';
import FilterPricing from '../../app-customer/profile/services/FilterPricing.vue';

const PromotionCart = () => import('../../app-customer/profile/promotion/PromotionCart.vue');
const FilterDetailsAutomatic = () => import('../../app-customer/profile/services/FilterDetails/FilterDetailsAutomatic.vue');
const PromotionSummary = () => import('../../app-customer/profile/promotion/PromotionSummary.vue');

// eslint-disable-next-line no-unused-vars
const servicesChildGuard = (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
	if (from.name) {
		next();
	} else {
		next('/konto/profil/uslugi-produkty');
	}
};

const promotionChildGuard = (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
	if (from.name) {
		next();
	} else {
		next('/konto/profil/promowanie');
	}
};

const filterPrefix = ':filterId' || 'dodaj-polecanie';

export default [
	{
		path: '/konto/profil/uslugi-produkty',
		name: 'Services',
		component: ServicesPage,
		// eslint-disable-next-line no-unused-vars
		beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
			if (Object.keys(to.query).length) {
				next(to.path);
			} else {
				next();
			}
		},
		children: [
			{
				name: 'FilterCreate',
				path: 'dodaj',
				component: FilterCreate,
				beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
					if (from.name !== 'Services') {
						next('/konto/profil/uslugi-produkty');

						return;
					}

					servicesChildGuard(to, from, next);
				},
			},
			{
				name: 'FilterListItem',
				path: ':categoryId',
				component: FilterListItem,
				beforeEnter: servicesChildGuard,
				children: [
					{
						name: 'FilterPricing',
						path: 'ceny',
						component: FilterPricing,
						beforeEnter: servicesChildGuard,
					},
					{
						name: 'FilterDetailsMatching',
						path: `${filterPrefix}/dopasowanie`,
						component: FilterDetailsMatching,
						beforeEnter: servicesChildGuard,
					},
					{
						name: 'FilterDetailsLocation',
						path: `${filterPrefix}/lokalizacje`,
						component: FilterDetailsLocation,
						beforeEnter: servicesChildGuard,
					},
					{
						name: 'FilterDetailsQuick',
						path: `${filterPrefix}/szybki-kontakt`,
						component: FilterDetailsQuick,
						beforeEnter: servicesChildGuard,
						children: [
							{
								name: 'FilterDetailsQuickMatching',
								path: 'dopasowanie',
								component: FilterDetailsMatching,
							},
							{
								name: 'FilterDetailsQuickLocation',
								path: 'lokalizacje',
								component: FilterDetailsLocation,
							},
						],
					},
					{
						name: 'FilterDetailsAutomatic',
						path: `${filterPrefix}/polecanie`,
						component: FilterDetailsAutomatic,
						beforeEnter: servicesChildGuard,
						children: [
							{
								name: 'FilterDetailsAutomaticMatching',
								path: 'dopasowanie',
								component: FilterDetailsMatching,
							},
							{
								name: 'FilterDetailsAutomaticLocation',
								path: 'lokalizacje',
								component: FilterDetailsLocation,
							},
						],
					},
				],
			},

		],
	},
	{
		path: '/konto/profil/promowanie',
		name: 'PromotionProfile',
		component: PromotionPage,
		beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
			if (Object.keys(to.query).length) {
				next(to.path);
			} else {
				next();
			}
		},
		children: [
			{
				name: 'PromotionSummary',
				path: 'podsumowanie',
				component: PromotionSummary,
				beforeEnter: promotionChildGuard,
			},
		],
	},
	{
		path: '/konto/profil/uslugi-produkty/:pathMatch(.*)*',
		name: 'NotFound',
		// eslint-disable-next-line no-unused-vars
		beforeEnter: (to: { params: { id: string; }; }, from: { path: string; }, next: (url?: string) => void) => {
			// @TODO 404 page
			next('/');
		},
	},
];
